import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import OpportunityTable from '../components/OpportunityTable';

function Opportunities() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>   
    <OpportunityTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Opportunities
